(() => {
  const selector = '.product--thumbnail_slider media-gallery';

  function enhanceGallery(gallery) {
    if (gallery.dataset.asCompactGallery === 'true') return;

    const rail = gallery.querySelector(':scope > .thumbnail-slider');
    const list = rail?.querySelector('.thumbnail-list');
    const previous = rail?.querySelector(':scope > .slider-button--prev');
    const next = rail?.querySelector(':scope > .slider-button--next');

    if (!rail || !list || !previous || !next) return;

    gallery.dataset.asCompactGallery = 'true';
    gallery.classList.add('as-compact-gallery--enhanced');
    previous.setAttribute('aria-label', 'Show previous product thumbnails');
    next.setAttribute('aria-label', 'Show next product thumbnails');

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const scrollRail = (direction) => {
      list.scrollBy({
        top: direction * list.clientHeight,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    };

    const updateButtons = () => {
      const hasOverflow = list.scrollHeight > list.clientHeight + 1;
      rail.classList.toggle('as-thumbnail-slider--no-overflow', !hasOverflow);
      previous.disabled = !hasOverflow || list.scrollTop <= 1;
      next.disabled = !hasOverflow || list.scrollTop + list.clientHeight >= list.scrollHeight - 1;
    };

    previous.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        scrollRail(-1);
      },
      true
    );
    next.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        scrollRail(1);
      },
      true
    );
    list.addEventListener('scroll', updateButtons, { passive: true });

    const keepActiveThumbnailVisible = () => {
      // The mobile gallery uses Dawn's horizontal scrolling.
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      const items = Array.from(list.querySelectorAll('.thumbnail-list__item'))
        .filter((item) => item.getClientRects().length && item.offsetHeight > 0);
      const active = list.querySelector('.thumbnail[aria-current="true"]')?.closest('.thumbnail-list__item');
      const index = items.indexOf(active);
      if (index < 0 || list.scrollHeight <= list.clientHeight + 1) return;

      const bounds = list.getBoundingClientRect();
      const viewportTop = bounds.top + list.clientTop;
      const viewportBottom = viewportTop + list.clientHeight;
      const activeBounds = active.getBoundingClientRect();
      const following = items[index + 1]?.getBoundingClientRect();
      const preceding = items[index - 1]?.getBoundingClientRect();
      let target = list.scrollTop;

      // When selecting the last visible photo, bring the next photo into view too.
      if (following && following.bottom > viewportBottom + 1 &&
          activeBounds.bottom > viewportBottom - activeBounds.height - 1) {
        target += Math.min(following.bottom - viewportBottom, activeBounds.top - viewportTop);
      } else if (preceding && preceding.top < viewportTop - 1 &&
                 activeBounds.top < viewportTop + activeBounds.height + 1) {
        target -= Math.min(viewportTop - preceding.top, viewportBottom - activeBounds.bottom);
      } else if (activeBounds.top < viewportTop) {
        target += activeBounds.top - viewportTop;
      } else if (activeBounds.bottom > viewportBottom) {
        target += activeBounds.bottom - viewportBottom;
      }

      target = Math.max(0, Math.min(target, list.scrollHeight - list.clientHeight));
      if (Math.abs(target - list.scrollTop) > 1) {
        list.scrollTo({ top: target, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
      updateButtons();
    };

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.type === 'childList' || mutation.attributeName === 'aria-current')) {
        window.requestAnimationFrame(keepActiveThumbnailVisible);
      }
    });
    observer.observe(list, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-current'] });

    updateButtons();
  }

  function initialise(root = document) {
    if (root.matches?.(selector)) enhanceGallery(root);
    root.querySelectorAll?.(selector).forEach(enhanceGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('as:gallery:updated', (event) => initialise(event.target));
})();


(() => {
  const productSelector = 'product-info[data-product-id="7702961848495"]';
  const frameDetails = [
    '46550914203823', '46550928556207', '46550953558191', '46550958506159',
    '29725898440879', '29725898473647', '29725898506415', '30100419117231'
  ];
  const mediaGroups = {
    '43082675978415': ['46550904799407', ...frameDetails, '38376708702383'],
    '43082764222639': ['46430544461999', ...frameDetails],
    '43082676011183': [
      '46638665466031', '46638698037423', '46638707081391',
      '46638712881327', '38376619147439'
    ],
    '43082676043951': ['46697131475119', '46697174565039', '46697197469871', '38376625799343'],
    '43082676076719': [
      '46694945423535', '46694953124015', '46694953484463',
      '46694957121711', '46694957351087', '46694962462895'
    ],
    '43354832240815': ['30286630060207', '46719936921775', '46719950618799', '46719948652719', '46719941673135'],
    '43082676109487': ['30286630027439', '46720390004911', '46720381092015', '46720391708847']
  };
  const controllers = new WeakMap();
  const mediaId = (element) => (element.dataset.mediaId || element.dataset.target || '').split('-').pop();

  function initialiseProduct(product) {
    const gallery = product.querySelector('media-gallery');
    if (!gallery) return null;
    if (controllers.has(gallery)) return controllers.get(gallery);

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const rail = gallery.querySelector('[id^="GalleryThumbnails"]');
    const list = rail?.querySelector('.thumbnail-list');
    const modal = document.getElementById('ProductModal-' + product.dataset.section);
    let selectedVariant = document.getElementById('product-form-' + product.dataset.section)?.querySelector('input[name="id"]')?.value;
    let pendingFrame;

    function showItem(element, visible) {
      element.hidden = !visible;
      if (visible) {
        element.style.removeProperty('display');
      } else {
        element.style.setProperty('display', 'none', 'important');
      }
    }

    function apply(variantId = selectedVariant) {
      selectedVariant = String(variantId || '');
      const group = mediaGroups[selectedVariant];
      if (!group || !gallery.isConnected) return;
      const allowed = new Set(group);
      const slides = Array.from(gallery.querySelectorAll('.product__media-list > [data-media-id]'));
      const visibleSlides = slides.filter((slide) => allowed.has(mediaId(slide)));
      if (!visibleSlides.length) return;

      slides.forEach((slide) => showItem(slide, allowed.has(mediaId(slide))));
      const thumbnails = Array.from(list?.querySelectorAll('[data-target]') || []);
      const visibleThumbnails = thumbnails.filter((thumbnail) => allowed.has(mediaId(thumbnail)));
      thumbnails.forEach((thumbnail) => showItem(thumbnail, allowed.has(mediaId(thumbnail))));
      visibleThumbnails.forEach((thumbnail, index) => {
        thumbnail.dataset.mediaPosition = String(index + 1);
        const button = thumbnail.querySelector('button');
        const label = button?.getAttribute('aria-label');
        if (label) button.setAttribute('aria-label', label.replace(/\d+/, String(index + 1)));
      });
      visibleSlides.forEach((slide, index) => {
        const opener = slide.querySelector('.product__media-toggle');
        const label = opener?.getAttribute('aria-label');
        if (label) opener.setAttribute('aria-label', label.replace(/\d+/, String(index + 1)));
        const text = opener?.querySelector('.visually-hidden');
        if (text) text.textContent = text.textContent.replace(/\d+/, String(index + 1));
      });
      modal?.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((item) => {
        showItem(item, allowed.has(mediaId(item)));
      });

      const active = slides.find((slide) => slide.classList.contains('is-active'));
      if (!active || !allowed.has(mediaId(active))) {
        gallery.setActiveMedia?.(visibleSlides[0].dataset.mediaId, false);
      }
      if (rail) showItem(rail, visibleThumbnails.length > 1);
      viewer?.resetPages?.();
      if (!window.matchMedia('(min-width: 750px)').matches) rail?.resetPages?.();
      if (visibleSlides.length === 1 && viewer) {
        viewer.currentPage = 1;
        viewer.totalPages = 1;
        viewer.querySelectorAll('.slider-counter--current, .slider-counter--total').forEach((counter) => {
          if (counter.textContent !== '1') counter.textContent = '1';
        });
        viewer.querySelectorAll('.slider-button').forEach((button) => { button.disabled = true; });
      } else {
        const total = viewer?.querySelector('.slider-counter--total');
        if (total && total.textContent !== String(visibleSlides.length)) total.textContent = String(visibleSlides.length);
      }
      const controls = viewer?.querySelector('.slider-buttons');
      if (controls) showItem(controls, visibleSlides.length > 1);
      list?.dispatchEvent(new Event('scroll'));
    }

    function queueApply() {
      window.cancelAnimationFrame(pendingFrame);
      pendingFrame = window.requestAnimationFrame(() => apply());
    }

    const observer = new MutationObserver(queueApply);
    const slideList = gallery.querySelector('.product__media-list');
    if (slideList) observer.observe(slideList, { childList: true });
    if (list) observer.observe(list, { childList: true });
    const modalContent = modal?.querySelector('.product-media-modal__content');
    if (modalContent) observer.observe(modalContent, { childList: true });
    const controller = { apply };
    controllers.set(gallery, controller);
    apply();
    return controller;
  }

  function initialise(root = document) {
    if (root.matches?.(productSelector)) initialiseProduct(root);
    root.querySelectorAll?.(productSelector).forEach(initialiseProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      document.querySelectorAll(productSelector).forEach((product) => {
        if (product.dataset.section !== data.sectionId) return;
        initialiseProduct(product)?.apply(data.variant?.id);
      });
    });
  }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();


